import { useCallback, useEffect, useRef, useState } from 'react';

export const DASHBOARD_LOAD_TIMEOUT_MS = 45000;

export default function useDashboardReport(request, emptyData) {
  const [data, setData] = useState(emptyData);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const active = useRef(null);

  const cancel = useCallback(() => {
    const previous = active.current;
    active.current = null;
    if (previous) {
      clearTimeout(previous.timer);
      previous.controller.abort();
    }
  }, []);

  const load = useCallback(async () => {
    cancel();
    const current = { controller: new AbortController() };
    active.current = current;
    setLoading(true);
    setError('');
    setData(emptyData);
    current.timer = setTimeout(() => {
      if (active.current !== current) return;
      cancel();
      setLoading(false);
      setError('Báo cáo chưa phản hồi sau 45 giây. Anh/chị bấm Thử lại để tải lại dữ liệu.');
    }, DASHBOARD_LOAD_TIMEOUT_MS);
    try {
      const response = await request(current.controller.signal);
      if (active.current === current) setData({ ...emptyData, ...(response || {}) });
    } catch (requestError) {
      if (active.current === current) setError(requestError?.message || 'Không thể tải báo cáo.');
    } finally {
      clearTimeout(current.timer);
      if (active.current === current) {
        active.current = null;
        setLoading(false);
      }
    }
  }, [cancel, emptyData, request]);

  useEffect(() => {
    load();
    return cancel;
  }, [load, cancel]);

  return { data, loading, error, load };
}
